import React from 'react';
import clsx from 'clsx';
import { GRID_STYLE } from '@utils/constants';

export const CardsContainer = ({
  children,
  fullWidth,
  hasFilter = false,
}: {
  children: React.ReactNode;
  fullWidth: boolean;
  hasFilter: boolean;
}) => {
  return (
    <div
      className={clsx(
        'mx-auto grid w-full flex-wrap justify-between gap-y-4 px-5 lt:px-0',
        GRID_STYLE,
        fullWidth && 'grid-cols-1	',
        hasFilter ? 'mt-3 md:mt-6' : 'mt-6',
      )}
    >
      {children}
    </div>
  );
};
